import { render, staticRenderFns } from "./journalismInfo1.vue?vue&type=template&id=684e3b9b&scoped=true&"
import script from "./journalismInfo1.vue?vue&type=script&lang=js&"
export * from "./journalismInfo1.vue?vue&type=script&lang=js&"
import style0 from "./journalismInfo1.vue?vue&type=style&index=0&id=684e3b9b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684e3b9b",
  null
  
)

export default component.exports